import { render, staticRenderFns } from "./ProdExtSku.vue?vue&type=template&id=1020c17e&"
import script from "./ProdExtSku.vue?vue&type=script&lang=js&"
export * from "./ProdExtSku.vue?vue&type=script&lang=js&"
import style0 from "./ProdExtSku.vue?vue&type=style&index=0&id=1020c17e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports